import { usePunditUserContext } from "@circle-react/contexts";

export const useIsPaywallsCheckoutFixValidationEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.paywalls_fix_checkout_tax_id_validation_enabled,
  );
};
